import { GroupData } from 'src/pages/Facebook/components/types';

export const isValidFBGroupURL = (url: string) => {
  return /^https:\/\/www\.facebook\.com\/groups\/(?:\d{15,16}|(?=.*[A-Za-z])[A-Za-z0-9._-]+)\/?$/.test(
    url,
  );
};

export const isValidFBGroupName = (name: string) => {
  return /^[a-zA-Z0-9 áéíóöőüűÁÉÍÓÖŐÜŰ_\-!@#$%^&*()_=+\[\]{};:'",.<>?/\\|`~]{1,75}$/.test(name);
};

const formattedGroupURL = (url: string) => url.replace(/\/$/, '');

export const isDuplicateGroupURL = (url: string, groupList: string[]) => {
  const formattedURL = formattedGroupURL(url);
  return groupList.some(url => formattedGroupURL(url) === formattedURL);
};

export const isDuplicateGroupName = (name: string, groupList: GroupData[]) => {
  return groupList.some(group => group.name === name);
};
